import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Header from './Header/Header';
import HeaderLinks from './Header/HeaderLinks';
import HomeFooter from './Footer/HomeFooter';
import { FONT_FAMILY } from '../common/sharedFunctions';

const accent = '#B7EE00';
const ink = '#111411';

const PublicPageLayout = ({
  children,
  contentMaxWidth = 'lg',
  eyebrow,
  icon,
  subtitle,
  title
}) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  return (
    <Box sx={{ backgroundColor: '#F3F5EE', minHeight: '100vh', overflowX: 'hidden' }}>
      <Header
        color="transparent"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{ height: 220, color: 'white' }}
      />

      <Box
        component="section"
        sx={{
          background: 'linear-gradient(135deg, #0A0E0C 0%, #121B2C 58%, #0D1322 100%)',
          color: '#FFFFFF',
          direction: isRTL ? 'rtl' : 'ltr',
          minHeight: { xs: 390, sm: 430 },
          overflow: 'hidden',
          pb: { xs: 10, sm: 12 },
          position: 'relative',
          pt: { xs: 15, sm: 17 }
        }}
      >
        <Box sx={{
          background: 'radial-gradient(circle, rgba(183,238,0,0.2) 0%, rgba(183,238,0,0) 68%)',
          height: 620,
          left: isRTL ? 'auto' : '-18%',
          pointerEvents: 'none',
          position: 'absolute',
          right: isRTL ? '-18%' : 'auto',
          top: '-72%',
          width: 620
        }} />
        <Box sx={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.14) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
          bottom: 0,
          maskImage: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
          opacity: 0.18,
          pointerEvents: 'none',
          position: 'absolute',
          right: isRTL ? 'auto' : 0,
          left: isRTL ? 0 : 'auto',
          top: 0,
          width: { xs: '60%', md: '42%' }
        }} />

        <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 }, position: 'relative' }}>
          <Box sx={{ maxWidth: 760 }}>
            <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mb: 2.25 }}>
              <Box sx={{
                alignItems: 'center',
                backgroundColor: accent,
                borderRadius: '13px',
                color: ink,
                display: 'flex',
                height: 44,
                justifyContent: 'center',
                width: 44
              }}>
                {icon}
              </Box>
              <Typography sx={{
                color: 'rgba(255,255,255,0.72)',
                fontFamily: FONT_FAMILY,
                fontSize: '0.75rem',
                fontWeight: 900,
                letterSpacing: '0.13em',
                textTransform: 'uppercase'
              }}>
                {eyebrow}
              </Typography>
            </Stack>
            <Typography component="h1" sx={{
              fontFamily: FONT_FAMILY,
              fontSize: { xs: '2.55rem', sm: '3.65rem', md: '4.2rem' },
              fontWeight: 900,
              letterSpacing: '-0.05em',
              lineHeight: 0.98,
              mb: 2.25,
              wordBreak: 'break-word'
            }}>
              {title}
            </Typography>
            <Typography sx={{
              color: 'rgba(255,255,255,0.7)',
              fontFamily: FONT_FAMILY,
              fontSize: { xs: '0.98rem', sm: '1.08rem' },
              lineHeight: 1.7,
              maxWidth: 650
            }}>
              {subtitle}
            </Typography>
          </Box>
        </Container>
      </Box>

      <Box component="main" sx={{ pb: { xs: 7, sm: 10 }, position: 'relative' }}>
        <Container
          maxWidth={contentMaxWidth}
          sx={{ mt: { xs: -6, sm: -8 }, px: { xs: 2, sm: 3 }, position: 'relative', zIndex: 3 }}
        >
          <Box sx={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E0E5DB',
            borderRadius: { xs: '22px', sm: '30px' },
            boxShadow: '0 28px 70px rgba(17,20,17,0.1)',
            direction: isRTL ? 'rtl' : 'ltr',
            overflow: 'hidden',
            p: { xs: 2.5, sm: 4, md: 5 }
          }}>
            {children}
          </Box>
        </Container>
      </Box>

      <HomeFooter />
    </Box>
  );
};

export default PublicPageLayout;
